import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "role-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { addCategoryApi } from '@/service/modules/sale';
export default /*#__PURE__*/_defineComponent({
  __name: 'second-category-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: 'addSubset'
    },
    itemData: {
      type: Object,
      default: () => {}
    },
    parentList: {
      type: Array,
      default: () => []
    },
    parentId: {
      required: true
    }
  },
  emits: ['closeDialog', 'restData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const form = reactive({
      parent_id: null,
      name: ''
    });
    const rules = {
      name: [{
        required: true,
        message: '请输入分组名称',
        trigger: 'blur'
      }, {
        min: 2,
        max: 8,
        message: '分组名称2~8位',
        trigger: 'blur'
      }],
      parent_id: [{
        required: true,
        message: '请选择父级分组',
        trigger: 'change'
      }]
    };
    function restForm() {
      form.parent_id = null;
      form.name = '';
      formRef.value?.resetFields();
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning('正在保存，请稍后~~');
      restForm();
      emit('closeDialog');
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      let params = {
        parent_id: form.parent_id,
        name: form.name
      };
      if (props.dialogType === 'edit') {
        params.id = props.itemData.id;
      }
      try {
        let res = await addCategoryApi(params);
        ElMessage.success(props.dialogType === 'add' ? '添加成功' : '修改成功');
        subBtnLoading.value = false;
        closeDialog();
        emit('restData');
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    const title = computed(() => {
      if (props.dialogType === 'add') {
        return '添加二级分组';
      } else if (props.dialogType === 'edit') {
        return '修改二级分组';
      }
    });
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(() => {
          form.parent_id = props.parentId;
          if (props.dialogType === 'edit') {
            form.name = props.itemData.name;
          }
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "父级分组",
            prop: "parent_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.parent_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.parent_id = $event),
              placeholder: "请选择父级分组",
              class: "w100",
              disabled: __props.dialogType === 'add'
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.parentList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 256))]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "分组名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.name = $event),
              placeholder: "请输入分组名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});